export default __webpack_public_path__ + "static/media/medium.152db0b4.png";